import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import { Paragraph } from 'elements/Text';

const Notes = () => {
  const { notepad } = useContext(GameContext);

  return notepad ? (
    <Paragraph>{notepad}</Paragraph>
  ) : null;
}

export default Notes;
